<template>
<div>
<div v-if="this.returnAccount!=-1">
          <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar style="width:60px;height:60px;">
              <v-img :src="'https://ndxfacegen.azurewebsites.net/home/ImageGenByName/'+this.returnAccount.yourName"></v-img>
            </v-list-item-avatar>
          </v-list-item>

          <v-list-item link>
            <v-list-item-content>
              <v-list-item-title class="title">
                {{this.returnAccount.yourName}}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{this.returnAccount.email}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list></div>
  
            <div v-else class="pa-5">
              <v-skeleton-loader
          v-bind="attrs"
        class="mb-5"
          type="avatar"
        ></v-skeleton-loader>
        <v-skeleton-loader class="mb-1"
          v-bind="attrs"
          type="heading"
        ></v-skeleton-loader>     <v-skeleton-loader
          v-bind="attrs"
          type="text@1"
        ></v-skeleton-loader>
        </div>
            </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex';

    export default {
         computed:{
      ...mapGetters(["returnAccount", "returnUserLoaded"]),
    },
  created: function () {
    // `this` points to the vm instance
    if(this.returnAccount==-1){
        this.loadAccount();
    }
 
  },

    methods: {
    ...mapActions(["loadAccount"]),
  
  },

    }
</script>

<style>

</style>
<style lang="scss" scoped>

</style>